export default __webpack_public_path__ + "static/media/10.eb7bd8db.jpg";